import { Point, PointResponse } from "../point/point.model";

export type PointGroupResponse = Omit<PointGroup, "points"> & {
  points: PointResponse[];
};
export class PointGroup {
  id: number;
  companyId: number;
  name: string;
  description?: string;
  points?: Point[];
  visiblePointIds: number[];
  graphicId?: number;
  graphicLink?: string;

  constructor(model: PointGroupResponse) {
    this.id = model.id;
    this.companyId = model.companyId;
    this.name = model.name;
    this.description = model.description;
    this.points = model.points?.map((p) => new Point(p));
    this.visiblePointIds = model.visiblePointIds || [];
    this.graphicId = model.graphicId;
    this.graphicLink = model.graphicLink;
  }
}
